// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section_wrapper__iFbgG","content":"Section_content__Ol5Nh","responsive":"Section_responsive__TBXc2"};